
import $ from "jquery"
import L from "plugins/leaflet/index"

import Sidebar from "components/map/sidebar/index"

import AppConfig from "app/config"

import AppMapZoomLevels from "app/map/zoom_levels/index"
import LeafletMapTileLayer from "app/map/leaflet/map_tile_layer"
import LeafletSettings from "app/map/leaflet/settings"


let leaflet_map = null as null | L.Map

// Internal
let markerImageURL = null as null | string
let buildingMapMarker = null as null | L.Marker


const hideMapMarker = () => {
  if (leaflet_map == null) { return }
  if (buildingMapMarker == null) { return }
  leaflet_map.removeLayer(buildingMapMarker)
}

/*
Set map marker to show building location
*/
function setMapMarker(lat: number, lng: number) {
  if (buildingMapMarker) { hideMapMarker() }
  if (markerImageURL == null) { return }

  buildingMapMarker = L.marker(
    L.latLng(lat, lng), {
      icon: L.icon({
        iconUrl:  markerImageURL,
        iconSize: [25, 29],
      }),
    }
  )

  if (leaflet_map == null) { return }
  leaflet_map.addLayer(buildingMapMarker)
  if (!leaflet_map.getBounds().contains(buildingMapMarker.getLatLng())) {
    return leaflet_map.panTo(buildingMapMarker.getLatLng(), {animate: false})
  }
}


/*
Initial map on neighbourhood
*/
function initialize($mapCanvas: JQuery) {
  const lat = parseFloat($mapCanvas.data("lat"))
  const lng = parseFloat($mapCanvas.data("lng"))
  const myCenter = L.latLng(lat, lng)
  const zoom = parseFloat($mapCanvas.data("zoom"))
  const coordinates = $mapCanvas.data("coordinates")
  markerImageURL = $mapCanvas.data("marker")

  const zoomControl = L.control.zoom({position: "topright"})



  // If we add map tile layer AFTER creating map object
  // The location of tile layer is drifted on load
  // To workaround this we create tile layer first and
  // pass it on map object creation
  LeafletMapTileLayer.getNewTileLayerPromise()
  .then((map_tile_layer) => {
    leaflet_map =
      LeafletSettings.get_use_baidu_maps() ?
        L.map("map-canvas", {
          center: myCenter,

          zoom:     zoom + 2,
          minZoom:  zoom - 2,
          maxZoom:  AppMapZoomLevels.max,

          // Interaction Options
          dragging:         false,
          touchZoom:        false,
          scrollWheelZoom:  false,
          doubleClickZoom:  false,
          boxZoom:          false,
          tap:              false,

          // Control options
          zoomControl:        false,
          attributionControl: false,

          layers: [
            map_tile_layer,
          ],
        })
        :
        L.map("map-canvas", {
          center: myCenter,

          zoom:     zoom + 2,
          minZoom:  zoom - 2,
          maxZoom:  AppMapZoomLevels.max,

          // Interaction Options
          dragging:         false,
          touchZoom:        false,
          scrollWheelZoom:  false,
          doubleClickZoom:  false,
          boxZoom:          false,
          tap:              false,

          // Control options
          zoomControl:        false,
          attributionControl: false,

          layers: [
            map_tile_layer,
          ],
        })

    leaflet_map.addControl(zoomControl)

    if (coordinates) {
      // Polygon
      const areaPolygon = L.polygon(coordinates)
      areaPolygon.setStyle({
        color:        AppConfig.colors.blue,
        opacity:      1,
        weight:       2,
        fillColor:    AppConfig.colors.blue,
        fillOpacity:  0.3,
      })

      areaPolygon.addTo(leaflet_map)
      // Auto fit on start
      leaflet_map.fitBounds(areaPolygon.getBounds(), {
        animate: false,
      })

    } else {
      // Auto fit on start
      leaflet_map.setZoom(13, {
        animate: false,
      })
    }

    // Setup map marker show
    $(".map-sidebar-record-row").on("mouseenter", ({currentTarget}) => {
      const $currentTarget = $(currentTarget)
      setMapMarker($currentTarget.data("lat"), $currentTarget.data("lng"))
    })

    // Initialize the sidebar
    Sidebar.initJSMapSidebarToggle($(".js-map-sidebar-toggle"))
  })
  .done()
}

export default {
  init: () => {
    initialize($("#map-canvas"))
  },
}
